<template>
    <div class="table-layout">
        <div ref="dataRef">
            <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
                <thead class="head">
                <tr class="row" style="height:40px;">
                    <td style="border: 1px solid #1a1a1a; text-align:center; font-size:14px;">机构全称</td>
                    <td style="border: 1px solid #1a1a1a; text-align:center; font-size:14px;">属性分组</td>
                    <td style="border: 1px solid #1a1a1a; text-align:center; font-size:14px;">字段名称</td>
                    <td style="border: 1px solid #1a1a1a; text-align:center; font-size:14px;">未通过原因</td>
                    <td style="border: 1px solid #1a1a1a; text-align:center; font-size:14px;">处理方式</td>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="(dataItem, index) in dataList">
                    <td style="border: 1px solid #1a1a1a; text-align:left;"><span>{{ dataItem.fullName }}</span></td>
                    <td style="border: 1px solid #1a1a1a; text-align:left;"><span>{{ dataItem.attrGroupName }}</span></td>
                    <td style="border: 1px solid #1a1a1a; text-align:left;"><span>{{ dataItem.attrItemName }}</span></td>
                    <td style="border: 1px solid #1a1a1a; text-align:left;"><span>{{ dataItem.unPassReason }}</span></td>
                    <td style="border: 1px solid #1a1a1a; text-align:left;"><span>{{ dataItem.handleMode }}</span></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    //
    export default {
        name: 'swb-org-state-change-check-dlg',
        desc: '组织机构状态前进校验弹框',
        props: ['checkList'],
        data: function () {
            return {
                dataList: []
            }
        },
        created: function () {
            let checkList = this.checkList || [];
            this.dataList = Utils.merge([], checkList);
        },
        methods: {
            getDlgResult: function () {
                let result = this.$refs.dataRef.innerHTML || '';
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/OrgStateChangCheckDlg.vue